import { createRoot } from 'react-dom/client';
import '@beautyburst/tokens/css';
import '@beautyburst/ui/styles';
import { BRAND_LOGO } from '@beautyburst/ui';
import { BrowserRetailerApp } from './browser-app.tsx';
import { retailerAsset } from './base-path.ts';

const root = document.getElementById('root');
if (root === null) throw new Error('Retailer portal root element is missing.');
const favicon = document.querySelector<HTMLLinkElement>('#beauty-burst-favicon');
if (favicon !== null) favicon.href = retailerAsset(BRAND_LOGO.mark);
createRoot(root).render(<BrowserRetailerApp />);
